import { calmTokens as t } from '../../shared/tokens';

const palettes = {
  bank: {
    ring: 'rgba(165,180,252,0.35)',
    bg: 'rgba(165,180,252,0.14)',
    fg: '#c7d2fe',
  },
  perso: {
    ring: 'rgba(134,239,172,0.35)',
    bg: 'rgba(134,239,172,0.12)',
    fg: '#bbf7d0',
  },
};

export default function CalmToggle({
  active = false,
  color = 'bank',
  icon,
  title,
  onClick,
  disabled = false,
}) {
  const p = palettes[color] || palettes.bank;

  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={active}
      aria-label={title}
      style={{
        position: 'relative',
        width: 'var(--tx-toggle, 34px)',
        height: 'var(--tx-toggle, 34px)',
        borderRadius: 10,
        background: active ? p.bg : 'transparent',
        border: `1px solid ${active ? p.ring : t.border}`,
        color: active ? p.fg : t.textMute,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'grid',
        placeItems: 'center',
        transition: 'all .15s',
        padding: 0,
      }}
    >
      {icon}
      {active && (
        <span
          style={{
            position: 'absolute',
            top: -3,
            right: -3,
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: p.fg,
            border: `2px solid ${t.surface}`,
            display: 'grid',
            placeItems: 'center',
            color: t.bg,
          }}
          aria-hidden="true"
        >
          <svg
            width="7"
            height="7"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </span>
      )}
    </button>
  );
}
